import * as React from "react";

export function exposeComponentAsClass<P>(Component: React.ComponentClass<P>): React.ComponentClass<P> {
    return class extends React.Component<P> {
        render() {
            return <Component {...this.props} />;
        }
    };
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1!./app/components/Navigation/exposeComponentAsClass.tsx